export default "__VITE_ASSET__708e0d14__"